// src/components/PrivacyPage.jsx
import React, { useEffect } from "react";
import styled from "styled-components";
import { useLanguage } from "./LanguageContext"; // უნდა აბრუნებდეს { language: 'ka' | 'en' }

const Page = styled.main`
  max-width: 980px;
  margin: 0 auto;
  padding: 28px 20px 60px;
  color: #0f0f0f;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  margin: 8px 0 16px;
  font-weight: 800;
`;

const Sub = styled.p`
  margin: 0 0 24px;
  color: #6b6b6b;
`;

const Section = styled.section`
  margin: 26px 0;
`;

const H2 = styled.h2`
  font-size: 1.15rem;
  margin: 0 0 10px;
  font-weight: 700;
`;

const P = styled.p`
  margin: 8px 0;
  line-height: 1.7;
  color: #222;
`;

const List = styled.ul`
  margin: 8px 0 8px 18px;
  line-height: 1.7;
  color: #222;
`;

const Badge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid rgba(0,0,0,0.08);
  background: rgba(17,24,39,0.06);
  font-size: 0.85rem;
  margin-left: 8px;
`;

const dict = {
  ka: {
    pageTitle: "კონფიდენციალურობის პოლიტიკა | Shopaholics",
    h1: "კონფიდენციალურობის პოლიტიკა",
    updated: "ბოლო განახლება: 2025",
    intro:
      "Shopaholics („ჩვენ“) ვაფასებთ თქვენს ნდობას და ვალდებულნი ვართ დავიცვათ თქვენი პირადი მონაცემები. ეს პოლიტიკა განმარტავს, რა მონაცემებს ვაგროვებთ, როგორ ვიყენებთ და რა უფლებები გაქვთ.",
    s1: "რა მონაცემებს ვაგროვებთ",
    d1: [
      "რეგისტრაციისას: სახელი, გვარი, ელფოსტა, ტელეფონის ნომერი, პაროლი.",
      "შეკვეთისას: მისამართი, ქალაქი/სოფელი, მიწოდების დეტალები.",
      "გადახდისას: ტრანზაქციის დეტალები (ამუშავებს ბანკი/გადახდის პროვაიდერი უსაფრთხოდ).",
      "ტექნიკური ინფორმაცია: IP მისამართი, ბრაუზერის ტიპი, Cookies.",
    ],
    s2: "როგორ ვიყენებთ მონაცემებს",
    d2: [
      "შეკვეთების დამუშავება და მიწოდება.",
      "გადახდის უსაფრთხო დამუშავება.",
      "მომხმარებლის მხარდაჭერა (support@shopaholics.ge).",
      "ანგარიშის და პროფილის მართვა.",
      "მარკეტინგული შეთავაზებები (მხოლოდ თქვენი თანხმობით).",
    ],
    s3: "ვინ იღებს წვდომას",
    d3: [
      "ჩვენი გუნდი (მხოლოდ საჭიროების ფარგლებში).",
      "გადახდის პარტნიორები: TBC Bank, Flitt.",
      "კურიერული/მიწოდების სერვისები.",
      "მესამე პირებზე მონაცემებს არ ვყიდით.",
    ],
    s4: "Cookies",
    p4:
      "Cookies ვიყენებთ საიტის ფუნქციონირებისა და ანალიტიკისთვის. სურვილის შემთხვევაში შეგიძლიათ გამორთოთ Cookies ბრაუზერის პარამეტრებიდან.",
    s5: "თქვენი უფლებები",
    d5: [
      "წვდომა საკუთარ მონაცემებზე.",
      "გასწორება/განახლება.",
      "წაშლის მოთხოვნა („დავიწყების უფლება“).",
      "მარკეტინგული შეტყობინებების გაუქმება ნებისმიერ დროს.",
    ],
    s6: "კონტაქტი",
    p6_1:
      "შეკითხვების შემთხვევაში დაგვიკავშირდით:",
    p6_2:
      "📧 support@shopaholics.ge   📞 +995 558 641 621",
    langBadge: "KA",
  },
  en: {
    pageTitle: "Privacy Policy | Shopaholics",
    h1: "Privacy Policy",
    updated: "Last Updated: 2025",
    intro:
      "At Shopaholics (“we”), we value your trust and are committed to protecting your personal data. This policy explains what we collect, how we use it, and your rights.",
    s1: "Data We Collect",
    d1: [
      "Registration: name, surname, email, phone number, password.",
      "Orders: address, city/village, delivery details.",
      "Payments: transaction details (securely processed by bank/payment provider).",
      "Technical data: IP address, browser type, cookies.",
    ],
    s2: "How We Use Your Data",
    d2: [
      "Process and deliver your orders.",
      "Handle payments securely.",
      "Provide customer support (support@shopaholics.ge).",
      "Manage your account and profile.",
      "Send marketing communications (only with consent).",
    ],
    s3: "Who Has Access",
    d3: [
      "Our internal team (on a need-to-know basis).",
      "Payment partners: TBC Bank, Flitt.",
      "Courier/shipping partners.",
      "We do not sell your data to third parties.",
    ],
    s4: "Cookies",
    p4:
      "We use cookies for functionality and analytics. You can disable cookies in your browser settings if you prefer.",
    s5: "Your Rights",
    d5: [
      "Access your personal data.",
      "Request corrections/updates.",
      "Request deletion (“right to be forgotten”).",
      "Unsubscribe from marketing at any time.",
    ],
    s6: "Contact",
    p6_1: "For any questions, contact us:",
    p6_2: "📧 support@shopaholics.ge   📞 +995 558 641 621",
    langBadge: "EN",
  },
};

const PrivacyPage = () => {
  const { language } = useLanguage(); // 'ka' | 'en'
  const i18n = dict[language] || dict.en;


 useEffect(() => {
   document.title = i18n.pageTitle;
   window.scrollTo({ top: 0, behavior: "smooth" });
 }, [language, i18n.pageTitle]);


  return (
    <Page>
      <Title>
        {i18n.h1} <Badge>{i18n.langBadge}</Badge>
      </Title>
      <Sub>{i18n.updated}</Sub>
      <P>{i18n.intro}</P>

      <Section>
        <H2>1. {i18n.s1}</H2>
        <List>
          {i18n.d1.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </List>
      </Section>

      <Section>
        <H2>2. {i18n.s2}</H2>
        <List>
          {i18n.d2.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </List>
      </Section>

      <Section>
        <H2>3. {i18n.s3}</H2>
        <List>
          {i18n.d3.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </List>
      </Section>

      <Section>
        <H2>4. {i18n.s4}</H2>
        <P>{i18n.p4}</P>
      </Section>

      <Section>
        <H2>5. {i18n.s5}</H2>
        <List>
          {i18n.d5.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </List>
      </Section>

      <Section>
        <H2>6. {i18n.s6}</H2>
        <P>{i18n.p6_1}</P>
        <P>{i18n.p6_2}</P>
      </Section>

      <Section>
        <P style={{ color: "#6b6b6b", fontSize: "0.95rem" }}>{i18n.note}</P>
      </Section>
    </Page>
  );
};

export default PrivacyPage;
